import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { Children } from "react";

export default function Option({
  categories,
  handleData,
  label,
  index,
  arabicLabel,
  fontStyle,
  field,
}) {
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        {/* <h3 style={fontStyle}>{`:${arabicLabel}`}</h3> */}
      </div>

      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">{label}</InputLabel>
        <Select
          fullWidth
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          label={label}
          onChange={(val) => handleData(val.target.value, field, index)}
        >
          {Children.toArray(
            categories.map((item) => <MenuItem value={item}>{item}</MenuItem>)
          )}
        </Select>
      </FormControl>
    </>
  );
}
